import {blockScroll, allowScroll} from "./utils/functions";

const $openMobileMenuButton = document.querySelector<HTMLButtonElement>("[data-open-mobile-menu]");
const $closeMobileMenuButton = document.querySelector<HTMLButtonElement>("[data-close-mobile-menu]");
const $mobileMenuElement = document.querySelector<HTMLDialogElement>("[data-mobile-menu-modal]");

const handleOpenMobileMenu = () => {
    if($mobileMenuElement) {
        if($openMobileMenuButton) {
            $openMobileMenuButton.hidden = true;
        }

        if($closeMobileMenuButton) {
            $closeMobileMenuButton.hidden = false;
        }
        $mobileMenuElement.show()
        blockScroll();
    }
}

const handleCloseMobileMenu = () => {
    if($mobileMenuElement) {
        if($openMobileMenuButton) {
            $openMobileMenuButton.hidden = false;
        }

        if($closeMobileMenuButton) {
            $closeMobileMenuButton.hidden = true;
        }
        $mobileMenuElement.close()
        allowScroll();
    }
}

if($openMobileMenuButton) {
    $openMobileMenuButton.addEventListener("click", handleOpenMobileMenu)
}

if($closeMobileMenuButton) {
    $closeMobileMenuButton.addEventListener("click", handleCloseMobileMenu)
}